module.exports = __webpack_public_path__ + "static/media/chills.cf0d1de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/chills.png
// module id = 393
// module chunks = 0